import { render } from "./PromptManagementQuestionDriven.vue?vue&type=template&id=b6daef90&scoped=true"
import script from "./PromptManagementQuestionDriven.vue?vue&type=script&lang=js"
export * from "./PromptManagementQuestionDriven.vue?vue&type=script&lang=js"

import "./PromptManagementQuestionDriven.vue?vue&type=style&index=0&id=b6daef90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6daef90"]])

export default __exports__